import { Box, Typography } from "@mui/material";
import React from "react";
import MedicalIcon from "../../../../assets/SVG/medicalIcon";
import { LabelInformation } from "../generalInformation";

export default function Medical({
  barometerCount,
  glucometerCount,
  examinationSetCount,
  bedCount,
  paravanCount,
  ecgCount,
  revivingBagCount,
  monitoringCount,
  electronicShockCount,
}) {
  return (
    <Box>
      <Typography className="styleSelectedTab">تجهیزات پزشکی</Typography>
      <Box display="flex" gap="20px" >
        <Box>
          <LabelInformation label="کاف فشارسنج" value={barometerCount}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="گلوکومتر" value={glucometerCount}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="ست معاینه پزشک" value={examinationSetCount}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="تخت" value={bedCount}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="پاراوان" value={paravanCount}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
        </Box>
        <Box>
          <LabelInformation label="نوارقلب" value={ecgCount}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="کیف احیا و ترالی" value={revivingBagCount}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="مونیتورینگ" value={monitoringCount}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
          <LabelInformation label="الکتروشوک" value={electronicShockCount}>
            <MedicalIcon color="#9A9A9A" />
          </LabelInformation>
        </Box>
      </Box>
    </Box>
  );
}
